import React from 'react';
import '../CSS/styles.css';

const renderParagraph = (paragraph, index) => <p key={index}>{paragraph}</p>;

const PrivacyPolicyPage = ({
  title,
  intro,
  sections,
  citations = [],
  effectiveDate,
  contactEmail,
}) => {
  return (
    <div className='container my-5'>
      <div className='row p-4 pb-0 pe-lg-0 pt-lg-5 align-items-center rounded-3 border shadow-lg'>
        <div className='row align-items-center g-5 py-5'>
          <div className='col-md-8 p-lg-5 mx-auto my-5'>
            <h1 className='display-5 fw-bold lh-1 mb-3'>{title}</h1>

            {intro.map(renderParagraph)}

            {sections.map(section => (
              <section className='mb-3' key={section.title}>
                <h5 className='text-dark fw-bold'>{section.title}</h5>
                {section.paragraphs.map(renderParagraph)}
              </section>
            ))}

            {citations.length > 0 && (
              <section className='mb-3'>
                <h5 className='text-dark fw-bold'>Health Information Sources</h5>
                <p>
                  CleanBowl is a wellness and nutrition tracking tool, not a
                  medical device. Health and nutrition calculations are
                  informational estimates and should not replace advice from a
                  qualified healthcare professional.
                </p>
                <ul className='ps-3'>
                  {citations.map(citation => (
                    <li key={citation.href}>
                      <a
                        href={citation.href}
                        className='text-dark fw-bold'
                        rel='noreferrer'
                        target='_blank'>
                        {citation.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </section>
            )}

            <section className='mb-3'>
              <h5 className='text-dark fw-bold'>Changes to This Privacy Policy</h5>
              <p>
                I may update this Privacy Policy from time to time. Any changes
                will be posted on this page.
              </p>
              <small className='text-muted'>Effective as of {effectiveDate}</small>
            </section>

            <section className='mb-3'>
              <h5 className='text-dark fw-bold'>Contact Us</h5>
              <p>
                If you have any questions or suggestions about this Privacy
                Policy, please contact:{' '}
                <a href={`mailto:${contactEmail}`} className='text-dark fw-bold'>
                  {contactEmail}
                </a>
                .
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
